var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.31,180.78a55.14,55.14,0,0,1,2.38-7.41,29.93,29.93,0,0,1,4.69-1,34.13,34.13,0,0,1,7.84,10.18c4.29-4.34,12.5-8.73,17.5-10.33a13.46,13.46,0,0,1,5,.63c-3.41,10.76-6.89,21.58-.72,24.36-.11,5.11.18,11.45.44,17.86-5.83-.64-28.95-1.75-38.34.31-.48-6.5-.65-12-.62-16.75C355.11,193.06,359.49,185.48,361.31,180.78Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.44,
    y: 389.21,
    width: 26.39,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.97,
    y: 397.82,
    width: 45.92,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.3,
    y: 399.53,
    width: 21.6,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 31.97,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.21,
    y: 395.31,
    width: 55.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.23,
    y: 81.31,
    width: 326.64,
    height: 141.69,
    transform: "translate(499.11 304.3) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.73,
    y: 81.31,
    width: 329.18,
    height: 141.69,
    transform: "translate(492.65 304.3) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: -4.36,
    width: 125.35,
    height: 313.03,
    transform: "translate(398.48 -94.18) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.91 214.82 187.21 89.48 162.3 89.48 198 214.82 222.91 214.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.93 214.82 155.24 89.48 138.08 89.48 173.78 214.82 190.93 214.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.78 214.82 337.09 89.48 312.17 89.48 347.87 214.82 372.78 214.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.81 214.82 305.11 89.48 287.96 89.48 323.65 214.82 340.81 214.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.51,
    y: 147.33,
    width: 125.35,
    height: 9.64,
    transform: "translate(306.34 -2.04) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.25,
    y: 147.33,
    width: 125.35,
    height: 9.64,
    transform: "translate(497.07 -192.77) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.87,
    y: 145.61,
    width: 136.61,
    height: 12.18,
    transform: "translate(302.88 0.53) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.61,
    y: 145.61,
    width: 136.61,
    height: 12.18,
    transform: "translate(493.62 -190.21) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.57,
    y: 151.72,
    width: 125.35,
    height: 0.86,
    transform: "translate(242.39 61.91) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.34,70.8H421.66a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H78.34a1,1,0,0,1-1-1h0A1,1,0,0,1,78.34,70.8Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.87,77.67h0a1.41,1.41,0,0,0,1.41-1.4v-3a1.41,1.41,0,0,0-1.41-1.41h0a1.41,1.41,0,0,0-1.4,1.41v3A1.4,1.4,0,0,0,412.87,77.67Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.05,77.67h0a1.41,1.41,0,0,0,1.41-1.4v-3a1.41,1.41,0,0,0-1.41-1.41h0a1.41,1.41,0,0,0-1.4,1.41v3A1.4,1.4,0,0,0,94.05,77.67Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.68,
    y: 71.84,
    width: 329.04,
    height: 35.44,
    transform: "translate(486.39 179.12) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76,331.7c3.55-1.2,6.12-4.62,3.87-8.13-3.73-5.8,5.6-7,3-16.73-3.69-13.7-15.16-1.83-18-15-2.07-9.57-18.14-15.84-18.77-3.24-.69,13.79-7.6,4.78-9.14,20.12-1.06,10.6,14,12.14,9.53,15.46-3.29,2.42-5.24,6.64-.65,9.53,6.26,3.93.35,7,4.61,9.74s4.94-1.63,11.54.5c5.9,1.9,10.9-3.93,9.73-7.58C189.35,333,191.2,332.91,194.76,331.7Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65,338s.48,44.4,19.09,44.4S198.83,338,198.83,338Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.94,331.7c3.54-1.2,6.12-4.62,3.86-8.13-3.73-5.8,5.61-7,3-16.73-3.7-13.7-15.17-1.83-18-15-2.07-9.57-18.14-15.84-18.77-3.24-.69,13.79-7.6,4.78-9.14,20.12-1.06,10.6,14,12.14,9.53,15.46-3.29,2.42-5.24,6.64-.64,9.53,6.25,3.93.35,7,4.6,9.74s4.94-1.63,11.54.5c5.91,1.9,10.91-3.93,9.73-7.58C137.52,333,139.37,332.91,142.94,331.7Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.82,338s.49,44.4,19.09,44.4S147,338,147,338Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.65,288.88c2.68-29.67,4.55-77.83,3.1-93.94a2,2,0,0,0-.75-1.4h0a1.86,1.86,0,0,0-3,1.66c.26,8,.55,27.93-1,62.35-.79,17.13-1.93,28.86-1.15,31.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,227.44c6.42-8,19.52-13.76,32.87-13.73,5.24,0-15.95,9.35-24.76,19.66-6.84,8-14.56,21.48-17.18,28.95C306.53,246.59,307.5,235.48,313.91,227.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,227.36c-6.34-8.84-21-15.64-36.85-16.41-6.23-.3,17.46,10.79,26.29,22.16,6.87,8.83,13.91,23.47,15.84,31.49C306.25,248,306.85,236.2,300.5,227.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,240.35c6.42-8,19.52-13.76,32.87-13.73,5.24,0-15.95,9.35-24.76,19.66-6.84,8-14.56,21.48-17.18,29C306.53,259.5,307.5,248.39,313.91,240.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,241c-6.34-8.84-21-15.64-36.85-16.41-6.23-.3,17.46,10.79,26.29,22.16,6.87,8.84,13.91,23.47,15.84,31.49C306.25,261.58,306.85,249.83,300.5,241Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.76,197.07c4.2-6,13.19-10.64,22.58-11.27,3.69-.25-10.85,7.36-16.65,15-4.51,6-9.42,15.82-11,21.21C308.3,210.9,308.55,203,312.76,197.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4,199.59c-4.47-6.23-14.8-11-26-11.56-4.39-.21,12.3,7.61,18.53,15.62,4.84,6.22,9.8,16.54,11.16,22.19C308.45,214.11,308.88,205.82,304.4,199.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,204.82c5.43-6.81,16.52-11.65,27.83-11.63,4.44,0-13.5,7.92-21,16.65-5.8,6.78-12.33,18.19-14.56,24.52C308,221,308.77,211.62,314.2,204.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,208.44C297.79,201,285.38,195.2,272,194.55c-5.27-.26,14.78,9.14,22.26,18.76C300,220.79,306,233.18,307.64,240,308,225.88,308.54,215.93,303.17,208.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.56,214.26c5.86-7.34,17.83-12.57,30-12.54,4.79,0-14.56,8.54-22.61,18-6.25,7.32-13.3,19.62-15.7,26.45C307.82,231.76,308.7,221.6,314.56,214.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.32,218.28c-6-8.31-19.74-14.7-34.65-15.42-5.85-.29,16.41,10.14,24.72,20.83,6.46,8.31,13.08,22.07,14.9,29.61C307.72,237.64,308.29,226.6,302.32,218.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,283.87l1,8.33a3.54,3.54,0,0,0,3.53,3.33H317a3.54,3.54,0,0,0,3.53-3.33l1-8.33a3.53,3.53,0,0,0-3.53-3.73H291.14A3.53,3.53,0,0,0,287.61,283.87Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.13,285.63H323a1.07,1.07,0,0,0,1.06-.94l.88-7.94a1.07,1.07,0,0,0-1.06-1.18H285.25a1.07,1.07,0,0,0-1.06,1.18l.88,7.94A1.07,1.07,0,0,0,286.13,285.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.93,
    y: 295.53,
    width: 16.02,
    height: 86.87,
    transform: "translate(477.89 677.93) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.74 382.4 230.94 382.4 230.94 365.77 240.77 365.77 235.74 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.51,
    y: 295.53,
    width: 16.02,
    height: 86.87,
    transform: "translate(877.04 677.93) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.93,
    y: 295.53,
    width: 203.77,
    height: 76.67,
    transform: "translate(665.64 667.73) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.9 382.4 434.7 382.4 434.7 365.77 424.87 365.77 429.9 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.66,
    y: 300.92,
    width: 196.32,
    height: 30.68,
    transform: "translate(665.64 632.53) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.43,310.46H399c4.68,0,9.16-3.79,12.39-10.47H251.05C254.27,306.67,258.75,310.46,263.43,310.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.66,
    y: 336.56,
    width: 196.32,
    height: 30.68,
    transform: "translate(665.64 703.8) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.43,346.09H399c4.68,0,9.16-3.78,12.39-10.46H251.05C254.27,342.31,258.75,346.09,263.43,346.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.24,275.17s-.88,20.36-34.46,20.36-34.45-20.36-34.45-20.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.24,264.6S431.36,285,397.78,285s-34.45-20.36-34.45-20.36Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.9,135.37c-6,3.28-8,13-5.19,17.23-10.4,3.12-5,21,12,22s29.94-5.21,21.59-18.47c8.26-11.13,4.46-23.56-2.78-22.19C385.75,118.37,359.73,118.83,367.9,135.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,175.8a14.51,14.51,0,0,1-7.44-2.08.26.26,0,1,1,.26-.44,14.1,14.1,0,0,0,18.13-3.14c2.73-3.38,4-8.8-.77-13.86a.25.25,0,1,1,.37-.35c4.94,5.3,3.65,11,.79,14.53A14.82,14.82,0,0,1,386,175.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,155.92a.25.25,0,0,1-.23-.17c-2.66-7.62.9-17.85,7.19-20.65a.27.27,0,0,1,.33.13.25.25,0,0,1-.13.33c-6.08,2.7-9.51,12.62-6.92,20a.25.25,0,0,1-.16.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.2,144.91l-.09,0a.26.26,0,0,1-.15-.32c1.8-4.77,5.2-8.4,8.86-9.48a.25.25,0,0,1,.14.48c-3.51,1-6.78,4.55-8.53,9.18A.25.25,0,0,1,359.2,144.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.2 410.91 367.42 410.92 366.45 389.21 376.18 389.45 373.2 410.91",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.15,223.57s-.51,60.25-1.78,86.48a18.27,18.27,0,0,0,0,2.34c1.9,26.29,5.05,76.82,5.05,76.82l9.79.25s8.53-40.35,3.25-76.9c8.49-41.34,13.06-78.23,5.37-89Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.55,247.5c-3,10.06-.08,42.4,1.47,57.32,2.11-10.78,3.91-21.15,5.24-30.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.77,408.11h7.51a.62.62,0,0,1,.64.56l.76,6.15a1.43,1.43,0,0,1-1.43,1.46c-3.31,0-4.89-.24-9.06-.23-2.57,0-4.12.26-7.67.26s-3.55-3.4-2.06-3.71c6.69-1.39,7.55-2.16,9.88-4A2.33,2.33,0,0,1,366.77,408.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.24,179.23c-.37,2.07-.79,4-1.24,6s-.91,4-1.44,6c-1.05,4-2.14,7.92-3.58,11.88a55.8,55.8,0,0,1-2.52,6,23.64,23.64,0,0,1-1.83,3.11c-.2.27-.38.53-.64.83a6.53,6.53,0,0,1-.83.88,6.84,6.84,0,0,1-2.7,1.57,6.5,6.5,0,0,1-3.26.13,7.81,7.81,0,0,1-2.4-1,12,12,0,0,1-2.94-2.66,21.5,21.5,0,0,1-3.35-5.86,2.1,2.1,0,0,1,3.45-2.24l.12.13a36.37,36.37,0,0,0,4,3.64,6.88,6.88,0,0,0,1.83,1c.24.06.41.06.43,0s-.14-.1-.28-.09-.23.06-.19,0a2,2,0,0,1,.16-.25,2.38,2.38,0,0,0,.26-.39,16.4,16.4,0,0,0,1.1-2.15,55.12,55.12,0,0,0,1.92-5.24c1.14-3.66,2.18-7.47,3.08-11.3s1.79-7.74,2.59-11.56v0a4.19,4.19,0,0,1,8.22,1.6Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.15,215.39c0,2.46,38.34,2.94,38.34-.31l-19.59-5-18.75,5.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.19,172.78a87.35,87.35,0,0,1,30.51.3,4.38,4.38,0,0,1,3.59,5.28c-5.42,24.27-5.11,32.43-4.59,45.21H363.16c-1.68-21.32-2.57-33.49-2.79-40.4C360.19,177.9,362,173.55,367.19,172.78Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,179.83a26.23,26.23,0,0,0,1.32,10c.43-2.31.93-4.79,1.5-7.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.69,155.06c-1,4.85-1.91,13.76,1.49,17,0,0-1.33,4.93-10.35,4.93-9.93,0-4.75-4.93-4.75-4.93,5.42-1.3,5.28-5.32,4.34-9.09Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.91,158.29,377.42,163a15.86,15.86,0,0,1,.47,2.68c2.07-.3,4.91-2.57,5.13-4.74A7.4,7.4,0,0,0,382.91,158.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.93,146.64c-1.86,7.91-2.47,11.3-7.21,14.71-7.12,5.14-16.44,1.14-17-7.17-.5-7.47,2.61-19.16,11-21A11.09,11.09,0,0,1,391.93,146.64Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,134.74c-8.38.93-5.83,16.55.47,18.06C396.76,149.19,401.31,135.48,388.91,134.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.93 396.61 424.14 398.37 415.69 380.67 424.6 378.24 429.93 396.61",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47,396.6l7.44-2.88a.59.59,0,0,1,.72.25l3.33,5.62a1.12,1.12,0,0,1-.57,1.6c-2.61,1-3.87,1.51-7.14,2.78-2,.78-5.14,3.38-7.92,4.45s-4-1.47-3-2.35a23.64,23.64,0,0,0,6.24-8.63A1.55,1.55,0,0,1,422.47,396.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.36,223.57s12.33,63.07,17,88c4.83,26,26.35,69.06,26.35,69.06l8.93-2.44s-12.23-46.06-17.93-68.89c-1.12-41.34.2-75-10-85.77Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.81,146.59c-.11.65-.54,1.12-1,1s-.68-.66-.57-1.31.55-1.12,1-1.05S378.93,145.94,378.81,146.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.46,145.34c-.11.65-.55,1.12-1,1s-.68-.65-.57-1.31.55-1.12,1-1S371.57,144.69,371.46,145.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.07,144.1l-1.49-.72S370.18,144.74,371.07,144.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.52,146.9a17.84,17.84,0,0,1-3,3.76,2.86,2.86,0,0,0,2.24.83Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.86,154.64a5.56,5.56,0,0,1-1-.09.19.19,0,0,1-.16-.22.2.2,0,0,1,.22-.16,5.26,5.26,0,0,0,4.55-1.3.19.19,0,0,1,.28,0,.2.2,0,0,1,0,.27A5.46,5.46,0,0,1,375.86,154.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.07,153.46a6,6,0,0,1-3.61,2.75c-2,.51-3-1.3-2.38-3.18.53-1.69,2.23-4,4.24-3.69A2.68,2.68,0,0,1,393.07,153.46Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,145.59a.38.38,0,0,1-.36-.27c-.53-1.71-2.72-2.45-2.74-2.45a.38.38,0,0,1-.25-.49.38.38,0,0,1,.49-.25c.1,0,2.59.87,3.24,3a.39.39,0,0,1-.26.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,141.56a.39.39,0,0,1-.33-.19.39.39,0,0,1,.15-.53,3.86,3.86,0,0,1,3.53-.24.39.39,0,0,1,.17.52.39.39,0,0,1-.52.17h0a3.12,3.12,0,0,0-2.8.22A.35.35,0,0,1,369.82,141.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,174.47c2.85,3.73,5.44,7.5,7.9,11.48,1.22,2,2.42,4,3.52,6.13a40.57,40.57,0,0,1,2.95,6.91c.11.32.19.69.28,1l.07.29.09.42a7.55,7.55,0,0,1,.08.79,10.32,10.32,0,0,1-.19,2.59,19.71,19.71,0,0,1-1.27,3.93,45.57,45.57,0,0,1-3.48,6.42,86.43,86.43,0,0,1-8.51,11.11,2.08,2.08,0,0,1-3.35-2.43l0-.05c2.21-3.85,4.4-7.81,6.29-11.73a49.34,49.34,0,0,0,2.41-5.83,12.62,12.62,0,0,0,.6-2.61,2.84,2.84,0,0,0,0-.79l0-.06h0l0-.12c-.07-.2-.12-.38-.21-.59a41.31,41.31,0,0,0-2.74-5.43c-1.1-1.85-2.27-3.7-3.47-5.55-2.44-3.66-5-7.34-7.6-10.9l0,0a4.19,4.19,0,0,1,6.72-5Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.43,145.35l-1.49-.72S377.53,146,378.43,145.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,180.78a55.14,55.14,0,0,1,2.38-7.41,29.93,29.93,0,0,1,4.69-1,34.13,34.13,0,0,1,7.84,10.18c4.29-4.34,12.5-8.73,17.5-10.33a13.46,13.46,0,0,1,5,.63c-3.41,10.76-6.89,21.58-.72,24.36-.11,5.11.18,11.45.44,17.86-5.83-.64-28.95-1.75-38.34.31-.48-6.5-.65-12-.62-16.75C355.11,193.06,359.49,185.48,361.31,180.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.5,200.79a.3.3,0,0,0-.24.18,8.9,8.9,0,0,0,.06,6.14c-.69-.58-1.37-1.15-2-1.73a7.18,7.18,0,0,0-.86-7.48.31.31,0,0,0-.27-.12.28.28,0,0,0-.24.18,8.84,8.84,0,0,0,.13,6.3c-.9-.82-1.76-1.64-2.55-2.43h0a7.16,7.16,0,0,0-.81-7.57.31.31,0,0,0-.27-.12.28.28,0,0,0-.24.18,8.92,8.92,0,0,0,.13,6.31c-1.37-1.43-2.51-2.73-3.36-3.81a7.38,7.38,0,0,0-4.87-5.21.31.31,0,0,0-.36.35c.9,4.43,4.16,5.2,4.82,5.31.47.59,1,1.24,1.64,1.94a8.47,8.47,0,0,0-5-.6.28.28,0,0,0-.21.21.31.31,0,0,0,.06.29,7,7,0,0,0,7.06,2.15c.56.58,1.16,1.17,1.79,1.78a9.69,9.69,0,0,0-6.41.38.3.3,0,0,0,0,.53,7.69,7.69,0,0,0,7.66.27c.84.79,1.73,1.58,2.65,2.37a9.12,9.12,0,0,0-6.51-.38.31.31,0,0,0-.19.24.33.33,0,0,0,.11.28,7.34,7.34,0,0,0,7.61,1l.08-.05a.23.23,0,0,0,.06-.12l1.13.92v0a.28.28,0,0,0,.14.1q.9.72,1.83,1.41a.3.3,0,0,0,.39,0l0,0a.3.3,0,0,0-.07-.42c-.57-.43-1.14-.86-1.69-1.31a7.19,7.19,0,0,0-.94-7.32A.3.3,0,0,0,370.5,200.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.64,185.3a.3.3,0,0,0,.24-.18,8.9,8.9,0,0,0-.06-6.14c.69.58,1.37,1.15,2,1.73a7.18,7.18,0,0,0,.86,7.48.31.31,0,0,0,.27.12.28.28,0,0,0,.24-.18,8.84,8.84,0,0,0-.13-6.3c.9.82,1.76,1.64,2.55,2.43h0a7.16,7.16,0,0,0,.81,7.57.31.31,0,0,0,.27.12.28.28,0,0,0,.24-.18,8.92,8.92,0,0,0-.13-6.31c1.37,1.43,2.51,2.73,3.36,3.81a7.38,7.38,0,0,0,4.87,5.21.31.31,0,0,0,.36-.35c-.9-4.43-4.16-5.2-4.82-5.31-.47-.59-1-1.24-1.64-1.94a8.37,8.37,0,0,0,5,.59.26.26,0,0,0,.21-.2.31.31,0,0,0-.06-.29,7,7,0,0,0-7.06-2.15c-.56-.58-1.16-1.17-1.79-1.78a9.69,9.69,0,0,0,6.41-.38.3.3,0,0,0,0-.53,7.69,7.69,0,0,0-7.66-.27c-.84-.79-1.73-1.58-2.65-2.37a9.12,9.12,0,0,0,6.51.38.33.33,0,0,0,.19-.24.33.33,0,0,0-.11-.28,7.34,7.34,0,0,0-7.61-1l-.08.05a.23.23,0,0,0-.06.12l-1.13-.92v0a.28.28,0,0,0-.14-.1q-.9-.72-1.83-1.41a.3.3,0,0,0-.39,0l0,0a.31.31,0,0,0,.06.42c.58.43,1.15.86,1.7,1.31a7.19,7.19,0,0,0,.94,7.32A.3.3,0,0,0,360.64,185.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.47,208.09a.32.32,0,0,0-.24.17,9,9,0,0,0,.06,6.14c-.69-.57-1.37-1.15-2-1.73a7.16,7.16,0,0,0-.86-7.47.3.3,0,0,0-.51.05,8.92,8.92,0,0,0,.13,6.31c-.9-.83-1.76-1.64-2.55-2.43h0a7.12,7.12,0,0,0-.81-7.56.28.28,0,0,0-.27-.12.31.31,0,0,0-.24.17,8.92,8.92,0,0,0,.13,6.31c-1.37-1.42-2.51-2.73-3.36-3.81a7.42,7.42,0,0,0-4.87-5.21.3.3,0,0,0-.27.08.32.32,0,0,0-.09.28c.9,4.42,4.17,5.19,4.82,5.3.47.59,1,1.25,1.64,1.95a8.46,8.46,0,0,0-5-.6.3.3,0,0,0-.21.21.29.29,0,0,0,.06.28,6.93,6.93,0,0,0,7.06,2.15c.56.58,1.16,1.18,1.79,1.79a9.62,9.62,0,0,0-6.41.38.33.33,0,0,0-.16.26.29.29,0,0,0,.15.26,7.7,7.7,0,0,0,7.66.28c.84.78,1.73,1.57,2.65,2.37a9.12,9.12,0,0,0-6.51-.38.31.31,0,0,0-.19.24.29.29,0,0,0,.12.27,7.34,7.34,0,0,0,7.61,1l.07-.06a.41.41,0,0,0,.07-.11l1.13.92h0a.26.26,0,0,0,.13.1c.6.48,1.21.95,1.83,1.42a.3.3,0,0,0,.39,0l0,0a.3.3,0,0,0-.06-.42c-.58-.43-1.14-.87-1.7-1.31a7.18,7.18,0,0,0-.93-7.32A.31.31,0,0,0,391.47,208.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,215a.28.28,0,0,0-.24.18,8.89,8.89,0,0,0,.05,6.14c-.69-.58-1.36-1.16-2-1.73a7.17,7.17,0,0,0-.85-7.48.31.31,0,0,0-.28-.12.31.31,0,0,0-.24.18,8.89,8.89,0,0,0,.13,6.3c-.9-.82-1.75-1.64-2.54-2.43h0a7.16,7.16,0,0,0-.81-7.57.31.31,0,0,0-.27-.12.28.28,0,0,0-.24.18,8.87,8.87,0,0,0,.13,6.31c-1.37-1.43-2.52-2.73-3.36-3.81a7.38,7.38,0,0,0-4.87-5.21.3.3,0,0,0-.36.35c.9,4.43,4.16,5.2,4.82,5.31.46.59,1,1.24,1.64,1.94a8.5,8.5,0,0,0-5-.6.32.32,0,0,0-.21.21.31.31,0,0,0,.07.29,7,7,0,0,0,7.05,2.15c.57.58,1.16,1.17,1.79,1.78a9.66,9.66,0,0,0-6.4.38.29.29,0,0,0-.16.26.32.32,0,0,0,.14.27,7.74,7.74,0,0,0,7.67.27q1.26,1.18,2.64,2.37a9.12,9.12,0,0,0-6.51-.38.28.28,0,0,0-.18.24.33.33,0,0,0,.11.28,7.35,7.35,0,0,0,7.61,1,.18.18,0,0,0,.07,0,.19.19,0,0,0,.07-.12l1.13.92v0a.31.31,0,0,0,.13.1q.9.72,1.83,1.41a.3.3,0,0,0,.39,0l0,0a.29.29,0,0,0-.06-.42l-1.7-1.31a7.18,7.18,0,0,0-.93-7.32A.31.31,0,0,0,410.7,215Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.73,216.13a.29.29,0,0,0-.24.17,8.89,8.89,0,0,0,.05,6.14c-.69-.57-1.36-1.15-2-1.73a7.17,7.17,0,0,0-.85-7.48.31.31,0,0,0-.52.06,8.92,8.92,0,0,0,.13,6.31c-.9-.83-1.75-1.64-2.54-2.43h0a7.16,7.16,0,0,0-.81-7.57.28.28,0,0,0-.27-.11.27.27,0,0,0-.24.17,8.87,8.87,0,0,0,.13,6.31,49.47,49.47,0,0,1-3.36-3.81,7.42,7.42,0,0,0-4.87-5.21.32.32,0,0,0-.28.08.34.34,0,0,0-.08.27c.9,4.43,4.16,5.2,4.82,5.31.46.59,1,1.24,1.64,2a8.34,8.34,0,0,0-5-.6.3.3,0,0,0-.21.2.31.31,0,0,0,.07.29,6.91,6.91,0,0,0,7.05,2.15c.57.58,1.16,1.18,1.79,1.79a9.54,9.54,0,0,0-6.4.38.28.28,0,0,0-.16.25.31.31,0,0,0,.14.27,7.72,7.72,0,0,0,7.67.28c.84.78,1.72,1.57,2.64,2.36a9.11,9.11,0,0,0-6.51-.37.28.28,0,0,0-.18.23.31.31,0,0,0,.11.28,7.35,7.35,0,0,0,7.61,1,.18.18,0,0,0,.07,0,.19.19,0,0,0,.07-.11l1.13.92h0a.31.31,0,0,0,.13.1c.61.48,1.21.95,1.83,1.42a.3.3,0,0,0,.39,0l0,0a.29.29,0,0,0-.06-.42l-1.7-1.31a7.2,7.2,0,0,0-.93-7.33A.28.28,0,0,0,366.73,216.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.83,174a.31.31,0,0,0-.24.18,9,9,0,0,0,.06,6.14c-.69-.58-1.37-1.15-2-1.73a7.18,7.18,0,0,0-.86-7.48.31.31,0,0,0-.27-.12.28.28,0,0,0-.24.18,8.89,8.89,0,0,0,.13,6.3c-.9-.82-1.76-1.64-2.55-2.43h0a7.16,7.16,0,0,0-.81-7.57.3.3,0,0,0-.27-.12.28.28,0,0,0-.24.18,8.92,8.92,0,0,0,.13,6.31c-1.37-1.43-2.51-2.73-3.36-3.81a7.38,7.38,0,0,0-4.87-5.21.31.31,0,0,0-.36.35c.9,4.43,4.17,5.2,4.82,5.31.47.59,1,1.24,1.64,1.94a8.46,8.46,0,0,0-5-.6.32.32,0,0,0-.21.21.31.31,0,0,0,.06.29,7,7,0,0,0,7.06,2.15c.56.58,1.16,1.17,1.79,1.78a9.69,9.69,0,0,0-6.41.38.33.33,0,0,0-.16.26.31.31,0,0,0,.15.27,7.69,7.69,0,0,0,7.66.27c.84.79,1.73,1.58,2.65,2.37a9.12,9.12,0,0,0-6.51-.38.31.31,0,0,0-.19.24.31.31,0,0,0,.12.28,7.33,7.33,0,0,0,7.6,1l.08-.05a.23.23,0,0,0,.06-.12l1.13.92v0a.33.33,0,0,0,.14.1q.9.72,1.83,1.41a.3.3,0,0,0,.39,0l0,0a.3.3,0,0,0-.06-.42c-.58-.43-1.14-.86-1.7-1.31a7.18,7.18,0,0,0-.93-7.32A.33.33,0,0,0,390.83,174Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.33,193a.29.29,0,0,0,.24-.17,8.89,8.89,0,0,0-.05-6.14c.69.57,1.36,1.15,2,1.73a7.17,7.17,0,0,0,.85,7.48.31.31,0,0,0,.52-.06,8.92,8.92,0,0,0-.13-6.31q1.35,1.24,2.55,2.43h0a7.16,7.16,0,0,0,.81,7.57.31.31,0,0,0,.52-.06,8.87,8.87,0,0,0-.14-6.31,49.47,49.47,0,0,1,3.36,3.81,7.41,7.41,0,0,0,4.88,5.21.3.3,0,0,0,.27-.08.32.32,0,0,0,.08-.28c-.89-4.42-4.16-5.19-4.82-5.3-.46-.59-1-1.24-1.64-2a8.34,8.34,0,0,0,5,.6.3.3,0,0,0,.21-.2.31.31,0,0,0-.07-.29,6.91,6.91,0,0,0-7.05-2.15c-.56-.58-1.16-1.18-1.79-1.79a9.54,9.54,0,0,0,6.4-.38.29.29,0,0,0,.16-.26.28.28,0,0,0-.14-.26,7.72,7.72,0,0,0-7.67-.28c-.84-.78-1.72-1.57-2.64-2.36a9.16,9.16,0,0,0,6.51.37.28.28,0,0,0,.18-.23.29.29,0,0,0-.11-.28,7.32,7.32,0,0,0-7.61-1,.18.18,0,0,0-.07,0,.41.41,0,0,0-.07.11l-1.13-.92h0a.26.26,0,0,0-.13-.1c-.6-.48-1.21-1-1.83-1.42a.3.3,0,0,0-.39,0l0,0a.3.3,0,0,0,.06.42l1.7,1.31a7.2,7.2,0,0,0,.93,7.33A.31.31,0,0,0,381.33,193Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,201.6l-67,6.76a6.78,6.78,0,0,0-6.06,7.42l2.3,22.91a12.23,12.23,0,1,1,2.14,21.17l2.31,22.91a6.8,6.8,0,0,0,7.42,6.07l67-6.75a6.81,6.81,0,0,0,6.07-7.43l-6.75-67A6.81,6.81,0,0,0,385.72,201.6Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,201.6l-67,6.76a6.78,6.78,0,0,0-6.06,7.42l2.3,22.91a12.23,12.23,0,1,1,2.14,21.17l2.31,22.91a6.8,6.8,0,0,0,7.42,6.07l67-6.75a6.81,6.81,0,0,0,6.07-7.43l-6.75-67A6.81,6.81,0,0,0,385.72,201.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,222.15l-3.1-1.35-7.28,1.86a3.9,3.9,0,0,0-2.1,1.39l-1.54,2a2.37,2.37,0,0,0,.13,3l1.74,1.92a2.38,2.38,0,0,0,3.31.2l3.95-3.39S403.87,225.55,404,222.15Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.89,209.66l3.22-.41a2,2,0,0,0,1.75-1.67l.44-2.56a2,2,0,0,0-2.15-2.37l-3.76.27a2,2,0,0,0-1.89,2.1l.1,2.7A2,2,0,0,0,340.89,209.66Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,136.17c-7.94,4-21.89,2.16-21.89,2.16S376.89,125.61,391,136.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "251.28 389.89 247.29 410.66 237.19 408.22 241.18 387.45 251.28 389.89",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.51,404l11.23,2.44a.71.71,0,0,1,.57.77l-.78,8.25a1.5,1.5,0,0,1-1.81,1.28c-3.53-.83-4.58-1.35-9.05-2.32-5.21-1.15-7.06-.84-13.18-2.18-3.7-.81-3.53-4.69-1.87-4.7a24.86,24.86,0,0,0,12.49-3.33A3.27,3.27,0,0,1,237.51,404Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.29 389.9 249.23 400.6 239.12 398.16 241.18 387.45 251.29 389.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.86,309.9c11.85-34.86,21.23-76,21.23-76l-33.8-2.14s-5,53.38-7.58,78c-2.7,25.58-11.09,83.33-11.09,83.33l15.25,3.09S267.17,341.8,268.86,309.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5,253.3l8.2,10.14c-2.09,7.83-4.53,16.63-7.21,25.62A176.83,176.83,0,0,1,274.5,253.3Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.84,395.26l14,3.06a1.16,1.16,0,0,0,1.35-.76l1.54-4.51a1.15,1.15,0,0,0-.83-1.5L238.71,388a1.16,1.16,0,0,0-1.42,1l-.35,5A1.16,1.16,0,0,0,237.84,395.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.84,395.26l14,3.06a1.16,1.16,0,0,0,1.35-.76l1.54-4.51a1.15,1.15,0,0,0-.83-1.5L238.71,388a1.16,1.16,0,0,0-1.42,1l-.35,5A1.16,1.16,0,0,0,237.84,395.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.88 389.17 307.51 410.6 297.26 410.46 296.63 389.03 306.88 389.17",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,406.06l10.9.16a.71.71,0,0,1,.71.64l.88,8.24a1.5,1.5,0,0,1-1.52,1.62c-3.62-.11-4.76-.41-9.33-.48-5.34-.09-6.49.58-12.75.49-3.79-.06-4.4-3.9-2.78-4.24a24.91,24.91,0,0,0,11.59-5.74A3.26,3.26,0,0,1,297,406.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.89 389.18 307.21 400.22 296.95 400.08 296.63 389.03 306.89 389.18",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.33,309.19c-2.9-36.67-.45-56.45-4.71-74.66l-30.76-1.91s9.55,53.9,14.82,78.28,10.94,83.6,10.94,83.6l15.12.19S311.59,337.8,304.33,309.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.66,397.22l14.31.22a1.16,1.16,0,0,0,1.17-1.08l.31-4.72a1.15,1.15,0,0,0-1.12-1.24l-15.57-.48a1.15,1.15,0,0,0-1.17,1.37l1,5A1.18,1.18,0,0,0,294.66,397.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.66,397.22l14.31.22a1.16,1.16,0,0,0,1.17-1.08l.31-4.72a1.15,1.15,0,0,0-1.12-1.24l-15.57-.48a1.15,1.15,0,0,0-1.17,1.37l1,5A1.18,1.18,0,0,0,294.66,397.22Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.87,176.21c-1.18,2.55-2.41,4.81-3.75,7.14s-2.75,4.59-4.31,6.81a64.66,64.66,0,0,1-5.16,6.55,30.65,30.65,0,0,1-7.17,6.08l-.35.2a4.91,4.91,0,0,1-4,.44c-1.95-.63-3.84-1.34-5.69-2.1s-3.65-1.6-5.42-2.48-3.5-1.81-5.2-2.81-3.36-2-5-3.21a3.09,3.09,0,0,1,2.53-5.52l.11,0c1.79.43,3.64.95,5.44,1.42l5.41,1.43c1.79.49,3.59.9,5.36,1.34s3.54.78,5.28,1.14l-4.31.65a24.33,24.33,0,0,0,4-4.22c1.37-1.76,2.69-3.7,4-5.7s2.5-4.09,3.68-6.21,2.38-4.31,3.44-6.33l.06-.11a6.16,6.16,0,0,1,11,5.46Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.33,158.73c-11.94,1.36-21,19.85-21,19.85l12.32,13.11s5.49-6.54,11.39-14.81C279.48,167.87,279.78,157.66,270.33,158.73Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.86,161.5c4.59-1.63,25.15,1,25.15,1-4,5.16-7.34,47.89-7.71,72.45-4.37.6-21.13-.55-25-1.45C261.8,223.86,265.82,178.64,268.86,161.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59,174.46A18.26,18.26,0,0,1,273.8,158.4a126.31,126.31,0,0,1,25.55,2.82A10,10,0,0,1,307,173.35c-6.33,26.55-4.66,51.74-6.35,63.46a49.37,49.37,0,0,1-18.84,3s.15-10.11,1.56-27.18c1.12-13.57,3.13-45.48,7.27-50.78,0,0-14.84-2-19.43-.39-3.41,19.25-5.91,77.56-5.91,77.57-7.26-.52-10.68-4.56-10.57-5.76C253.26,209.68,254,188.29,255.59,174.46Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17,144.93c-1.39,4-3,11.09-.43,15.07a1.53,1.53,0,0,1-.63,2.28,22.81,22.81,0,0,1-13.65,2.94c-6.45-.52-6-3.43-4.34-5.32a2.32,2.32,0,0,1,1.52-.76c6.09-.73,6.15-4.4,5.27-8Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.17,147.48l-7.25,3.69a11.54,11.54,0,0,1,.39,2.61c2.64,0,6.38-1.77,6.81-3.8A5.17,5.17,0,0,0,286.17,147.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.62,
    cy: 130.66,
    rx: 6.55,
    ry: 4.89,
    transform: "translate(125.5 396.65) rotate(-85.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.09,134c-1.34,7.89-1.73,12.58-6.11,16.25-6.59,5.51-15.84.85-16.84-7.28-.91-7.31,1.43-19,9.41-21.36S296.43,126.1,295.09,134Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,140.67c-.1,0-.22-.13-.33-.07-3.58,2-4.74-2.3-4.52-5.16a6.8,6.8,0,0,1,2.65-4.88c-3.88.44-7.64-2.06-7.7-4.39-4.29,1.89-9.46,2-11.79-2s1-9.23,5.44-7.84c-1.8-3.22,5.81-9.66,13.78-.16.25-6.89,11.39,0,9.56,6.77,5.16,1.78,9.58,11.58.83,13.67C300.71,145.69,293.37,140.67,293.37,140.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.59,143.15a7.58,7.58,0,0,1-4.84,2.72c-2.4.27-2.93-2.17-1.7-4.39,1.11-2,3.69-4.54,5.83-3.76S299.15,141.25,297.59,143.15Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,134.59c-.06.66-.45,1.15-.88,1.11s-.73-.6-.67-1.26.45-1.14.88-1.1S283.7,133.94,283.65,134.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,133.73c-.06.65-.45,1.14-.88,1.1s-.72-.6-.67-1.25.45-1.15.88-1.11S276,133.07,275.9,133.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.93,134.1a23.37,23.37,0,0,1-3.61,5.28,3.79,3.79,0,0,0,3.06.89Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.4,143.45a5.38,5.38,0,0,0,4-1.39.19.19,0,0,0-.28-.27,5.15,5.15,0,0,1-4.53,1.17.18.18,0,0,0-.22.15.2.2,0,0,0,.15.23C279.84,143.39,280.12,143.43,280.4,143.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.21,133a.42.42,0,0,0,.19,0,.38.38,0,0,0,.19-.51,3.89,3.89,0,0,0-2.68-2.29.39.39,0,0,0-.44.32.39.39,0,0,0,.32.44h0a3.1,3.1,0,0,1,2.1,1.84A.41.41,0,0,0,286.21,133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.65,130.54a.4.4,0,0,0,.36-.08,3.06,3.06,0,0,1,2.67-.73.38.38,0,0,0,.47-.26.39.39,0,0,0-.26-.48,3.79,3.79,0,0,0-3.39.89.38.38,0,0,0,0,.54A.36.36,0,0,0,272.65,130.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.38,172.81c.65,1.27,1.18,2.37,1.7,3.56s1,2.34,1.52,3.52c1,2.36,1.87,4.76,2.69,7.19a98.67,98.67,0,0,1,3.82,15.07l.27,2,.14,1,0,.24,0,.44c0,.32.05.64.05,1a15.39,15.39,0,0,1-1.07,5.32,39.32,39.32,0,0,1-3.78,7.39,72.44,72.44,0,0,1-4.47,6.29,75.66,75.66,0,0,1-5,5.77,3.08,3.08,0,0,1-5-3.48l0-.08c2.07-4.31,4.26-8.67,6-12.92.45-1.06.85-2.12,1.2-3.15a25.63,25.63,0,0,0,.87-2.94,5.74,5.74,0,0,0,.17-1.9.08.08,0,0,0,0,0s0,.06,0,0l-.05-.2-.19-.83-.37-1.65a119.59,119.59,0,0,0-4.23-13.2c-.8-2.2-1.71-4.37-2.59-6.55-.44-1.08-.91-2.16-1.38-3.23l-1.4-3.12-.08-.18a6.15,6.15,0,0,1,11.1-5.3Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,161.5c13.32,3.36,17,20.39,17,20.39l-16.54,11.86s-4.1-4.29-5.34-14.37C294.93,174.57,297.68,161.37,300.38,161.5Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.43,226l-7.7,2.88,5.9,7.9s6.65-3.45,5.39-7.28Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,230a12.21,12.21,0,0,0-6.18.56l3.82-22.7a6.79,6.79,0,0,0-5.56-7.81l-66.4-11.18a6.79,6.79,0,0,0-7.8,5.55L203,217.17a12,12,0,0,1,6.18-.56,12.22,12.22,0,1,1-9.71,21.55l-3.83,22.7a6.79,6.79,0,0,0,5.56,7.81l66.4,11.18a6.8,6.8,0,0,0,7.81-5.55l3.82-22.71A12.22,12.22,0,1,0,289,230Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,230a12.21,12.21,0,0,0-6.18.56l3.82-22.7a6.79,6.79,0,0,0-5.56-7.81l-66.4-11.18a6.79,6.79,0,0,0-7.8,5.55L203,217.17a12,12,0,0,1,6.18-.56,12.22,12.22,0,1,1-9.71,21.55l-3.83,22.7a6.79,6.79,0,0,0,5.56,7.81l66.4,11.18a6.8,6.8,0,0,0,7.81-5.55l3.82-22.71A12.22,12.22,0,1,0,289,230Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,236.64l2.53,2.42a2.84,2.84,0,0,0,3.68.22l3.29-2.47-5.9-7.9-3.65,3.66A2.84,2.84,0,0,0,291.13,236.64Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,191l.92-3.41a2.06,2.06,0,0,1,2-1.32h0a10.07,10.07,0,0,1,3.83.59l5.2,1.92-.25,2.12c-.21,1.82-2.24,3.34-4.54,3.41a19.33,19.33,0,0,1-4.59-.49l-.56-.12A2.22,2.22,0,0,1,217,191Z",
    style: {
      fill: "#7f3e3b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.09,143.93c3.33-3.87,8.34-13.92-1.08-17.76-6.95-2.84-21.7-1.39-30.17,11.8-5.79,2-7.5,14.88,5.87,17.59S135.09,143.93,135.09,143.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.3 392.08 150.02 393.35 152.61 411.31 165.38 410.27 165.3 392.08",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.3 392.09 150.01 393.36 151.47 403.42 165.35 402.27 165.3 392.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.09,339.21c-6-23-21.54-50.38-11.69-72.51l42.81-.13s1.06,45.55,1.36,67C168.87,356,167,398.2,167,398.2l-17.51,1.33S137.49,365,136.09,339.21Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62,400.22l18.92-1.39a.68.68,0,0,0,.62-.63l.4-7a.66.66,0,0,0-.74-.7l-21,2.79a.65.65,0,0,0-.55.84l1.66,5.62A.68.68,0,0,0,148.62,400.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25,288.47a114.67,114.67,0,0,0,.66,16.27c2.09,7.23,4.76,14.47,7.16,21.49C135.21,306.35,135.22,283.18,124.25,288.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.74 393.2 93.4 393.35 93.38 411.45 106.2 411.35 108.74 393.2",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.17,408.67a.73.73,0,0,1,.9-.6c3.85,1.53,11.15.36,13.91-.17a2.27,2.27,0,0,1,1.77.37,29.22,29.22,0,0,0,7.27,3.36,8.63,8.63,0,0,1,.4,4.61l-25.86,0A50.47,50.47,0,0,0,92.17,408.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92,408.67a.73.73,0,0,1,.9-.6c3.85,1.53,11.15.36,13.91-.17a2.27,2.27,0,0,1,1.77.37c2.94,2.08,10.78,3.36,10.78,3.36a8.56,8.56,0,0,1,.39,4.61l-29.36,0A50.47,50.47,0,0,0,150.92,408.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.74 393.21 93.39 393.35 93.38 403.49 107.32 403.37 108.74 393.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.24,331.77c-2.08-23.23-8.6-54.52-1.2-65.2h50.1s-10.21,46.32-14.4,67.76c-4.35,22.29-16.86,65.09-16.86,65.09l-16.59.05S86,358.29,91.24,331.77Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.25,394.72a.51.51,0,0,1-.48-.36c-1.19-4-1-49.95,2-62.53,0-1.66-.35-4.92-.75-9.05-1.37-14-3.91-40-.12-54.75a.5.5,0,0,1,1,.25c-3.75,14.59-1.22,40.49.14,54.41.41,4.2.74,7.51.76,9.19a.57.57,0,0,1,0,.13c-2.88,11.9-3.16,58.2-2,62.07a.5.5,0,0,1-.33.62A.39.39,0,0,1,94.25,394.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14,400.09h18.79a.62.62,0,0,0,.63-.52l1.24-6.67a.69.69,0,0,0-.7-.81L90.64,393a.63.63,0,0,0-.61.69l.42,5.76A.7.7,0,0,0,91.14,400.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.16,185.66c1,4,1.92,8,2.81,12s1.73,8,2.51,12l1.2,6,1.12,6c.77,4,1.45,8.06,2.15,12.1l-1.63-3.65a3.38,3.38,0,0,0,1.33,1.84,11.39,11.39,0,0,0,4.24,1.75,32.36,32.36,0,0,0,6.16.81c1.11.06,2.25.1,3.4.08.57,0,1.15,0,1.73,0s1.21,0,1.61,0l1.42.1a5.52,5.52,0,0,1,2.28,10.36c-.8.44-1.37.77-2.05,1.12s-1.31.65-2,1c-1.34.58-2.71,1.13-4.13,1.59a42.09,42.09,0,0,1-4.39,1.18,41.13,41.13,0,0,1-4.73.66,29.75,29.75,0,0,1-5.15-.08,22.94,22.94,0,0,1-5.58-1.18,23.3,23.3,0,0,1-5.71-2.82,22.72,22.72,0,0,1-4.92-4.63,7.27,7.27,0,0,1-1.32-2.54l-.31-1.11c-1.1-3.94-2.23-7.87-3.27-11.83l-1.59-5.92-1.51-5.94c-1-4-2-7.94-2.91-11.92s-1.82-8-2.61-12v0a11.2,11.2,0,0,1,21.84-4.94Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.09,235.58l.21,6.46c2.61,6.27,10.09,1.51,10.09,1.51l4.52-.83a3.44,3.44,0,0,0,2.58-3.61l-.12-4.52A3.58,3.58,0,0,0,197,230.9l-4,.08a7.06,7.06,0,0,0-3.33.9Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5,174.52c9.2,4.84,15.21,21.92,15.21,21.92-1.94,8-9.76,22.59-17,22.5,0,0-10.63-13.71-11.78-23.63C134.53,183.32,130.9,164.74,149.5,174.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,171.68a193,193,0,0,0-42.65.68c-8.18,1.15-14,6.24-13,23,2,34-1.1,60.5,3.22,72.72,0,0,62.92,18,80.86.75,4.36-40.91-10.32-74.87-17-89A14.33,14.33,0,0,0,141,171.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,175.4c-1.63-1.6-3.34-.67-4.13-3.08a8.32,8.32,0,0,1,.9-5.53l-19.41-10.48c.38,7.14.67,12.78-2.5,15.62-.92,5.32,9,10.63,22.21,10.71C141.75,182.69,138.62,177.7,136.27,175.4Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.75,167.39l-15.32-3.83c3.87,6.09,10.84,9.42,14.59,7.95A8.42,8.42,0,0,1,132.75,167.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.41,132.45c-10.14-2.25-18.9,6.17-16.94,15.35s3.51,15.38,9.86,18.5c12.62,6.22,18.78.22,19.81-9.37C140.07,148.29,136.7,134.72,126.41,132.45Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,148.75a4.67,4.67,0,0,0-3.51.51A9.06,9.06,0,0,0,124.42,148.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.49,149.6a3.82,3.82,0,0,0-3,1.24A7.54,7.54,0,0,0,124.49,149.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,155.56c5.67,1.27,8-1.57,8-4.75,0-3.38-3.19-9.09-6.69-10.14,1.25-7.5,21.92,3,19.95-7.39,0,0-.56-1.78-5.9-2.78s-19.61,2.22-18.61,12.89S110.75,155.56,110.75,155.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.53,138.5a13.61,13.61,0,0,0,1.11-9S110.86,133.61,103.53,138.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.61,158.41a8.56,8.56,0,0,0,1.26-.19.25.25,0,0,0,.19-.3.24.24,0,0,0-.3-.19,6.86,6.86,0,0,1-6-1.38.25.25,0,0,0-.36,0,.26.26,0,0,0,0,.36A7.1,7.1,0,0,0,129.61,158.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.16,156a8.29,8.29,0,0,0,5.46,3.28c2.91.4,4-2.29,2.88-4.83-1-2.29-3.72-5.25-6.48-4.49S105.58,153.81,107.16,156Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.07,148.85c.12.81.64,1.41,1.17,1.33s.87-.81.75-1.62-.63-1.4-1.16-1.32S126,148,126.07,148.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,147.57c.12.82.64,1.41,1.17,1.33s.87-.8.75-1.61-.63-1.41-1.16-1.33S135.49,146.76,135.6,147.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,148.64l.46,6.86s2.25.39,3.47-.91A14,14,0,0,0,132,148.64Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.93,147a.47.47,0,0,1-.57-.6,4.85,4.85,0,0,1,2.92-3.31.48.48,0,0,1,.6.31.49.49,0,0,1-.31.61h0a3.86,3.86,0,0,0-2.29,2.65A.48.48,0,0,1,122.93,147Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,143.93a.45.45,0,0,1-.41-.19,3.77,3.77,0,0,0-3.06-1.63.48.48,0,0,1,0-1,4.71,4.71,0,0,1,3.89,2,.48.48,0,0,1-.11.67A.43.43,0,0,1,138.73,143.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,209.33a12.11,12.11,0,0,0-5.86,2l-1.81-23a6.8,6.8,0,0,0-7.29-6.22l-67.13,5.29a6.81,6.81,0,0,0-6.22,7.29l5.3,67.13a6.78,6.78,0,0,0,7.29,6.22l67.12-5.3a6.8,6.8,0,0,0,6.23-7.29l-1.82-22.95a12.07,12.07,0,0,0,6.11,1.1A12.22,12.22,0,0,0,197,209.33Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,200.15l-1,1.84-1.15,2.06c-.74,1.4-1.5,2.8-2.19,4.22a89.22,89.22,0,0,0-3.72,8.5c-.53,1.4-1,2.79-1.35,4.16a31.78,31.78,0,0,0-.94,4,20.88,20.88,0,0,0-.21,6.6l-2.3-4A16.93,16.93,0,0,0,90.19,231a51.71,51.71,0,0,0,5.33,3.73c1.93,1.24,4,2.43,6.08,3.62l3.18,1.77c1,.6,2.2,1.2,3.15,1.78l.48.29a5.66,5.66,0,0,1-3,10.5c-1.52,0-2.82-.1-4.22-.21s-2.73-.28-4.09-.5a66.92,66.92,0,0,1-8.19-1.76,53.32,53.32,0,0,1-8.3-3.09,32.34,32.34,0,0,1-8.61-5.8,7.74,7.74,0,0,1-2-3.15l-.28-.86A36.94,36.94,0,0,1,68,222.57a57.44,57.44,0,0,1,2.48-12.78A81.25,81.25,0,0,1,75,198.41c.87-1.8,1.76-3.58,2.76-5.31.49-.87,1-1.74,1.52-2.6l.82-1.3.43-.66.52-.77a11.19,11.19,0,0,1,19,11.81Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.85,174.52c-16.58,8.86-22.76,28.65-22.76,28.65,3.28,6.25,23.06,13,30.5,11.16,0,0,7.13-13,8.6-24.62C109.55,178.94,101.56,169.33,91.85,174.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45,243l.34,6.46c2.74,6.22,10.12,1.31,10.12,1.31l4.51-.92a3.43,3.43,0,0,0,2.5-3.66l-.2-4.51A3.59,3.59,0,0,0,117.3,238l-4,.16a7.05,7.05,0,0,0-3.31,1Z",
    style: {
      fill: "#ffc3bd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC24);
export default __webpack_public_path__ + "static/media/c24.be847c50e40bd0725537b4687c661f87.svg";
export { ForwardRef as ReactComponent };